import { render, staticRenderFns } from "./camelliaLoginButton.vue?vue&type=template&id=3fa897b6&scoped=true&"
import script from "./camelliaLoginButton.vue?vue&type=script&lang=js&"
export * from "./camelliaLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./camelliaLoginButton.vue?vue&type=style&index=0&id=3fa897b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa897b6",
  null
  
)

export default component.exports